import * as React from 'react';
import { DynamicResultTable } from '../../dynamic-result-table';
import { FormattedDate } from '../../formatted';
import { Invoice, DunningStatus } from '@atlassian/cssxp-types-billing';
import { Maybe } from '@css-xp/graphtypes';
import { startCase } from 'lodash';
import './payment-retry-v2.scss';

type DunningInfo = Invoice['dunningStatus'];

interface Props {
  dunningInfo?: DunningInfo;
}

const headers = ['Retried on', 'Retry', 'Error', 'Next retry on'];

const wrapInCell = (node: React.ReactElement | string) => {
  return <div className="payment-retry-cell">{node}</div>;
};

const makeHead = () => {
  const cells = headers?.map((header) => {
    return {
      content: wrapInCell(header),
    };
  });
  return {
    cells,
  };
};

const makeColumns = (dunningInfo: DunningStatus[] | undefined) => {
  return dunningInfo?.map((dunningStatus: Maybe<DunningStatus>, index) => {
    const rowKey = `dunning-row-${index}`;
    const declineCode = dunningStatus?.declineCode ? `(${startCase(dunningStatus?.declineCode)})` : '';
    return {
      key: rowKey,
      cells: [
        {
          content: wrapInCell(<FormattedDate date={dunningStatus?.paymentRetryDate} showTime />),
        },
        {
          content: wrapInCell(`# ${dunningStatus?.attemptCount}`),
        },
        {
          content: wrapInCell(` ${startCase(dunningStatus?.errorCode)} ${declineCode}`),
        },
        {
          content: wrapInCell(<FormattedDate date={dunningStatus?.nextPaymentAttempDate} />),
        },
      ],
    };
  });
};

const emptyStateProps = {
  header: 'No payment retries found',
  description: '',
};

const PaymentRetryV2 = ({ dunningInfo }: Props) => {
  const data = dunningInfo?.reverse();
  return (
    <div className="payment-retry-log-v2-container" data-testid="invoice-payment-retry-log">
      <DynamicResultTable
        header={<h4 className="heading">Payment retry log</h4>}
        head={makeHead()}
        rows={makeColumns(data)}
        loadingSpinnerSize="small"
        emptyStateProps={emptyStateProps}
      />
    </div>
  );
};

export default PaymentRetryV2;
